import * as React from 'react';

type Props = {
    shouldRefresh: boolean;
    children: React.ReactNode;
    pathname: string;
};

type State = {
    isRefreshing: boolean;
};

export class RefreshingPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isRefreshing: false,
        };
    }

    UNSAFE_componentWillReceiveProps(prevProps: Props) {
        if (prevProps.pathname !== this.props.pathname && this.props.shouldRefresh) {
            this.setState({isRefreshing: true});

            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined') {
                // @ts-expect-error
                window.trackJs.console.info('Refreshing page due to version change!');
            }

            location.reload();
        }
    }

    render() {
        return this.state.isRefreshing ? null : this.props.children;
    }
}
